module.exports = __webpack_public_path__ + "static/media/icons-ic-decision-call-transferred.9fafc54c.svg";